import { createSlice } from "@reduxjs/toolkit";

const courseSlice = createSlice({
  name: "course",
  initialState: {
    data: {},
  },
  reducers: {
    setCourseData: (state, action) => {
      const { coursesData } = action.payload;
      state.data = coursesData;
    },
  },
});

export const { setCourseData } = courseSlice.actions;
export default courseSlice.reducer;
